export default "__VITE_ASSET__DcqxpY7C__"